import axiosInstance from "../../utils/axiosCompany";

export const CreateInventory = async (values) => {
    return await axiosInstance().post("company/inventory/add-inventory", values);
}

export const GetInventoryList = async (values) => {
    return await axiosInstance().post("company/inventory/list-inventories", values);
}

export const GetAllInventories = async (values) => {
    return await axiosInstance().post("company/inventory/get-all-inventories", values);
}

export const GetSingleInventory  = async (values) => {
    return await axiosInstance().post("company/inventory/get-single-inventory", values);
}

export const EditInventory = async (values) => {
    return await axiosInstance().post("company/inventory/update-inventory", values)
}

export const ChangeInventoryStatus = async (values) => {
    return await axiosInstance().post("company/inventory/change-inventory-status", values)
}

export const DeleteInventory = async (values) => {
    return await axiosInstance().post("company/inventory/delete-inventory", values);
}


export const getOutletInventoryStockList = async (values) => {
    return await axiosInstance().post("company/inventory/get-outlet-inventory-stock-list", values);
}

export const ImportedInventory = async (values) => {
    return await axiosInstance().post("company/inventory/validate-import-file", values);
}

// export const ImportedInventoryValidate = async (values) => {
//     return await axiosInstance().post("company/inventory/validate-imported-file", values);
// }

export const GetInventoryEndOfDaysList = async (values) => {
    return await axiosInstance().post("company/inventory/list-inventories-end-of-days", values);
}
export const CreateInventoryEndOfDaysCount = async (values) => {
    return await axiosInstance().post("company/inventory/add-inventory-end-of-days", values);
}
// Past end-of-day counts, one row per submitted EOD.
// brand_id, outlet_id, page and per_page are required; sort and search are
// optional JSON strings (sort order: 1 = ASC, 2 = DESC).
export const GetInventoryEndOfDayHistories = async (values) => {
    return await axiosInstance().post("company/inventory/list-inventory-end-of-day-histories", values);
}

// One history row with the counts recorded against it.
export const GetInventoryEndOfDayHistory = async (values) => {
    return await axiosInstance().post("company/inventory/get-inventory-end-of-day-history", values);
}

// Raw material prices imported from a spreadsheet: the list page parses and
// validates the sheet, then posts { brand_id, prices } where prices is a JSON
// array of { sku, price }.
export const ImportInventoryPrices = async (values) => {
    return await axiosInstance().post("company/inventory/import-prices", values);
}
